export enum COLORS {
  Base = '#fefefe',
  Primary = '#45C5A9',
  Secondary = '#2E3E4F',
  TextOnBase = '#10161d', // base = background / neutral
  TextOnPrimary = '#10161d',
  TextOnSecondary = '#fefefe'
}
